import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { postMethod } from "../../services/ApiCallMethods";

export const downloadDocuments = createAsyncThunk(
  "document/downloadDocuments",
  async ({ docIds }, { rejectWithValue }) => {
    try {
      const response = await postMethod(
        `/api/document/download`,
        { docIds }
      );

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", "documents.zip");

      document.body.appendChild(link);
      link.click();
      link.remove();

      return true;
    } catch (error) {
      console.error("Error downloading documents:", error);
      return rejectWithValue(
        error?.response?.data || "Failed to download documents"
      );
    }
  }
);

const initialState = {
  downloadLoading: false,
  downloadError: null,
  downloadSuccess: false,
};

const documentDownloadSlice = createSlice({
  name: "documentDownload",
  initialState,
  reducers: {
    resetDownloadState: (state) => {
      state.downloadLoading = false;
      state.downloadError = null;
      state.downloadSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(downloadDocuments.pending, (state) => {
        state.downloadLoading = true;
        state.downloadError = null;
        state.downloadSuccess = false;
      })
      .addCase(downloadDocuments.fulfilled, (state) => {
        state.downloadLoading = false;
        state.downloadSuccess = true;
      })
      .addCase(downloadDocuments.rejected, (state, action) => {
        state.downloadLoading = false;
        state.downloadError = action.payload;
        state.downloadSuccess = false;
      });
  },
});

export const { resetDownloadState } = documentDownloadSlice.actions;

export default documentDownloadSlice.reducer;
